// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Bnds","paramInput":"JobSimulator_paramInput__BUX_y","input":"JobSimulator_input__1eT2W"};